import {Component, Input, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ChangeRecordLogicService} from '@app/logic/change-records/change-record.logic-service';
import {IWorkingDrawingMappedItem} from '@app/logic/working-drawings';
import {
    IUnassignedChangeRecordDto,
    IWorkingDrawingChangeDto,
    WORKING_DRAWING_CHANGE_STATUS_ENUM
} from '@classictechsolutions/hubapi-transpiled-enums';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { take } from 'rxjs';

@Component({
    selector: 'cb-working-drawings-assigned-changes',
    templateUrl: './working-drawings-assigned-changes.component.html',
    styleUrls: ['./working-drawings-assigned-changes.component.scss'],
    standalone: false
})
export class WorkingDrawingsAssignedChangesComponent implements OnInit {

    private _mappedItem: IWorkingDrawingMappedItem;
    @Input() public set mappedItem(_workingDrawing: IWorkingDrawingMappedItem) {
        this._mappedItem = _workingDrawing;
        this.assignedChangeRecords = _workingDrawing.changes;
    }

    public get mappedItem(): IWorkingDrawingMappedItem {
        return this._mappedItem;
    }

    @Input() public parentForm: NgForm;

    protected readonly WORKING_DRAWING_CHANGE_STATUS_ENUM = WORKING_DRAWING_CHANGE_STATUS_ENUM;

    public assignedChangeRecords: IWorkingDrawingChangeDto[] = [];
    public unassignedChangeRecords: IUnassignedChangeRecordDto[] = [];

    constructor(private readonly changeRecordLogicService: ChangeRecordLogicService) {}

    public drop(event: CdkDragDrop<any[]>): void {
        if (event.previousContainer === event.container) {
            if (event.previousIndex !== event.currentIndex) {
                moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
            }
        } else {
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex
            );
        }
    }

    public ngOnInit(): void {
        this.loadUnassignedChangeRecords();
    }

    private loadUnassignedChangeRecords(): void {
        this.changeRecordLogicService
            .getUnassignedChangeRecords(this.mappedItem.lotId)
            .pipe(take(1)).subscribe((results: any) => {
                this.unassignedChangeRecords = results || [];
            });
    }
}
